import React, { FunctionComponent } from 'react';
import { SIGN_UP_STATES } from '@jetslash/market-frontend-shared-core/src/models/user';
import useSignUpWizard from '@/hooks/useSignUpWizard';
import { ICurrentUser } from '@jetslash/market-frontend-shared-core/src/types/models/user';
import SignUpForm from '../forms/signUpFlow/SignUpForm';
import SignUpEmailVerificationInstructions from '../authorization/SignUpEmailVerificationInstructions';
import SignUpPhoneNumberEntryForm from '../forms/signUpFlow/SignUpPhoneNumberEntryForm';
import SignUpPhoneNumberConfirmationForm from '../forms/signUpFlow/SignUpPhoneNumberConfirmationForm';

interface IProps {
  signUpUser: ICurrentUser;
}

const SignUpStateForm: FunctionComponent<IProps> = ({ signUpUser }) => {
  const { signUpState } = signUpUser || {};
  const { errors, loading } = useSignUpWizard();

  if (!signUpState || signUpState === SIGN_UP_STATES.newMarketUser) {
    return <SignUpForm loading={loading} errors={errors} />;
  }
  if (signUpState === SIGN_UP_STATES.emailIsUnconfirmed) {
    return <SignUpEmailVerificationInstructions signUpUser={signUpUser} loading={loading} errors={errors} />;
  }
  if (signUpState === SIGN_UP_STATES.phoneNumberIsMissing) {
    return <SignUpPhoneNumberEntryForm errors={errors} loading={loading} signUpUser={signUpUser} />;
  }
  if (signUpState === SIGN_UP_STATES.phoneNumberTryAgain) {
    // user tries to enter in their phone number again, so we don't want to auto-poll for current user
    return <SignUpPhoneNumberEntryForm errors={errors} loading={loading} signUpUser={signUpUser} doNotPoll />;
  }
  if (signUpState === SIGN_UP_STATES.phoneNumberIsUnconfirmed) {
    return <SignUpPhoneNumberConfirmationForm errors={errors} loading={loading} signUpUser={signUpUser} />;
  }
  if (signUpState === SIGN_UP_STATES.accountFullyConfirmed) {
    // Skeleton component while page loads
    return <div style={{ height: 150 }} />;
  }

  return null;
};

export default SignUpStateForm;
